import { FC } from "preact/compat";
import { useEffect } from "preact/hooks";
import { useApp } from "~/core/store";
import { IconButton } from "~/components";
import Popup from "./Popup";
import CloseIcon from "@material-design-icons/svg/outlined/close.svg";
import ScheduleIcon from "@material-design-icons/svg/outlined/schedule.svg";
import Loader from "~/assets/loader.svg";

const TrackerMobile: FC = () => {
    const {
        mobile: { isTrackerOpen, isTrackerPage, toggleTracker },
        tracker: { loading, load },
    } = useApp();
    const isCloseIcon = isTrackerOpen.value || isTrackerPage.value;

    useEffect(() => {
        load();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <>
            <div className="flex min-w-[50px] items-center justify-center text-sm text-white">
                <IconButton
                    flat
                    title={isCloseIcon ? "Close tracker" : "Open tracker"}
                    disabled={loading.value}
                    onClick={() => toggleTracker()}
                >
                    {loading.value ? (
                        <Loader
                            width="20"
                            height="20"
                            className="text-sky-500"
                        />
                    ) : isCloseIcon ? (
                        <CloseIcon width="24" height="24" />
                    ) : (
                        <ScheduleIcon width="24" height="24" />
                    )}
                </IconButton>
            </div>
            <Popup />
        </>
    );
};

export default TrackerMobile;
